export default function isMacOs() {
  const userAgent = window.navigator?.userAgent;
  return userAgent.indexOf('Mac OS') !== -1;
}
